<div class="lm-modal__container" [attr.data-testid]="getRef(id)">
  <div class="lm-modal__content" [ngClass]="cssModifier ? 'lm-modal__content--' + cssModifier : ''">
    <button
      class="lm-modal__close"
      [attr.data-testid]="getRef(id, 'close-btn')"
      [ngClass]="cssModifier ? 'lm-modal__close--' + cssModifier : ''"
      (click)="close()"
    >
      <ng-container *ngIf="cssModifier === 'checkout'; else xMarkIcon">
        <i class="fa fa-chevron-left lm-modal__close--checkout-icon"></i>
      </ng-container>
      <ng-template #xMarkIcon>
        <svg
          fill="none"
          height="11"
          viewBox="0 0 10 11"
          width="10"
          xmlns="http://www.w3.org/2000/svg"
          class="lm-modal__icon"
          [ngClass]="cssModifier ? 'lm-modal__icon--' + cssModifier : ''"
        >
          <path
            clip-rule="evenodd"
            d="M5.00096 6.06321L8.93919 10.0031L10.0001 8.94261L6.06141 5.00234L9.99983 1.0623L8.93895 0.00185597L5.00096 3.94146L1.06112 0L0.000241101 1.06044L3.94052 5.00234L0 8.94447L1.06088 10.0049L5.00096 6.06321Z"
            fill="#0A0A0A"
            fill-rule="evenodd"
          />
        </svg>
      </ng-template>
    </button>
    <ng-content></ng-content>
  </div>
</div>
<div class="lm-modal__background"></div>
